import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function VolunteerPage({ onBack, go }) {
  const [volunteerOpen, setVolunteerOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [volunteerError, setVolunteerError] = useState("");

  const openVolunteerForm = () => {
    setVolunteerError("");
    setSubmitted(false);
    setVolunteerOpen(true);
  };

  const closeVolunteerForm = () => {
    if (!submitting) {
      setVolunteerOpen(false);
      setVolunteerError("");
      setSubmitted(false);
    }
  };

  const submitVolunteer = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const data = new FormData(form);

    setSubmitting(true);
    setVolunteerError("");

    try {
      await api.post("/volunteers", {
        name: data.get("name"),
        phone: data.get("phone"),
        area: data.get("area"),
        interest: data.get("interest"),
        message: data.get("message"),
      });

      form.reset();
      setSubmitted(true);

      setTimeout(() => {
        setVolunteerOpen(false);
        setSubmitted(false);
      }, 2200);
    } catch (error) {
      setVolunteerError(
        error.response?.data?.detail ||
        "Unable to submit your volunteer request. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="volunteer-page">
	
	<div className="volunteer-page-back">
		  <button
			type="button"
			className="volunteer-secondary-btn volunteer-back-btn"
			onClick={onBack}
		  >
			<ArrowLeft size={17} />
			Back to Home
		  </button>
		</div>

      <section className="volunteer-hero">
        <div className="volunteer-hero-inner">

          <div className="volunteer-hero-copy">
            <span className="volunteer-kicker">
              CIVIC LEADERSHIP • COMMUNITY SERVICE
            </span>

            <h1>
              Young people can lead by
              <span> serving their community.</span>
            </h1>

            <p className="volunteer-hero-text">
              Leadership begins with listening, taking responsibility and
              helping people solve everyday problems. Join a civic volunteer
              initiative where young residents can learn, contribute and
              create meaningful change in their communities.
            </p>

            <div className="volunteer-hero-actions">
              <button
                type="button"
                className="volunteer-primary-btn"
                onClick={openVolunteerForm}
              >
                <Users size={18} />
                Become a Volunteer
              </button>

              <a href="#volunteer-opportunities" className="volunteer-secondary-btn">
                Explore Opportunities
              </a>
            </div>

            <div className="volunteer-trust-line">
              <ShieldCheck size={18} />
              <span>
                Open to residents interested in community service and civic
                participation.
              </span>
            </div>
          </div>

          <div className="volunteer-hero-photo-wrap">
            <div className="volunteer-photo-glow"></div>

            <div className="volunteer-photo-card">
              <img
                src="/images/author-portrait.webp"
                alt="SM Shailesh"
                className="volunteer-hero-photo"
              />

              <div className="volunteer-photo-caption">
                <strong>SM Shailesh</strong>
                <span>Civic initiative coordinator</span>
              </div>
            </div>
          </div>

        </div>
      </section>


      <section className="volunteer-intro">
        <div className="volunteer-section-heading">
          <span className="volunteer-kicker">WHY VOLUNTEER?</span>
          <h2>Leadership is built through service.</h2>
          <p>
            A strong community needs people who are willing to listen,
            understand local concerns and work constructively with others.
            Volunteering is an opportunity to develop those skills through
            real community experience.
          </p>
        </div>

        <div className="volunteer-values-grid">

          <div className="volunteer-value-card">
            <div className="volunteer-value-icon">
              <Users size={22} />
            </div>
            <h3>Listen to People</h3>
            <p>
              Understand the concerns, needs and experiences of residents
              before looking for solutions.
            </p>
          </div>

          <div className="volunteer-value-card">
            <div className="volunteer-value-icon">
              <HeartHandshake size={22} />
            </div>
            <h3>Serve with Empathy</h3>
            <p>
              Help people navigate civic services and connect them with
              appropriate information and resources.
            </p>
          </div>

          <div className="volunteer-value-card">
            <div className="volunteer-value-icon">
              <Lightbulb size={22} />
            </div>
            <h3>Learn Leadership</h3>
            <p>
              Build communication, teamwork, organisation and problem-solving
              skills through practical community work.
            </p>
          </div>

          <div className="volunteer-value-card">
            <div className="volunteer-value-icon">
              <MapPin size={22} />
            </div>
            <h3>Improve Your Community</h3>
            <p>
              Help identify local civic concerns and support constructive
              efforts to improve neighbourhoods.
            </p>
          </div>

        </div>
      </section>


      <section className="volunteer-message">
        <div className="volunteer-message-inner">

          <div className="volunteer-message-mark">
            “
          </div>

          <div>
            <span className="volunteer-kicker">A MESSAGE FOR YOUNG VOLUNTEERS</span>

            <h2>
              Don't wait for a title to start making a difference.
            </h2>

            <p>
              Real leadership starts with small acts of responsibility:
              helping a neighbour, listening to a concern, understanding how
              a civic service works, bringing people together and following
              through on a promise.
            </p>

            <p>
              If you are young and want to develop your leadership abilities,
              community volunteering can give you the experience, discipline
              and perspective that no classroom can provide on its own.
            </p>

            <div className="volunteer-message-sign">
              <strong>SM Shailesh</strong>
              <span>Community & civic initiative</span>
            </div>
          </div>

        </div>
      </section>


      <section id="volunteer-opportunities" className="volunteer-opportunities">
        <div className="volunteer-section-heading">
          <span className="volunteer-kicker">HOW YOU CAN HELP</span>
          <h2>Choose an area where you can contribute.</h2>
          <p>
            Volunteers can participate according to their interests, skills
            and available time.
          </p>
        </div>

        <div className="volunteer-opportunity-grid">

          <div className="volunteer-opportunity">
            <Users size={22} />
            <h3>Community Outreach</h3>
            <p>
              Speak with residents, listen to local concerns and help share
              information about civic services.
            </p>
          </div>

          <div className="volunteer-opportunity">
            <FileText size={22} />
            <h3>Civic Awareness</h3>
            <p>
              Help residents understand how to report civic problems and
              follow the progress of their complaints.
            </p>
          </div>

          <div className="volunteer-opportunity">
            <MapPin size={22} />
            <h3>Neighbourhood Observation</h3>
            <p>
              Identify visible civic concerns such as damaged roads,
              drainage issues, waste problems and street-light concerns.
            </p>
          </div>

          <div className="volunteer-opportunity">
            <MessageSquare size={22} />
            <h3>Communication</h3>
            <p>
              Help collect feedback and communicate community information
              clearly and respectfully.
            </p>
          </div>

          <div className="volunteer-opportunity">
            <Lightbulb size={22} />
            <h3>Youth Initiatives</h3>
            <p>
              Bring ideas for constructive community activities, awareness
              drives and neighbourhood improvement.
            </p>
          </div>

          <div className="volunteer-opportunity">
            <HeartHandshake size={22} />
            <h3>Community Service</h3>
            <p>
              Participate in activities that support residents and promote
              cleaner, safer and better-connected neighbourhoods.
            </p>
          </div>

        </div>
      </section>


      <section className="volunteer-steps">
        <div className="volunteer-section-heading">
          <span className="volunteer-kicker">GET STARTED</span>
          <h2>Your journey can start with one simple step.</h2>
        </div>

        <div className="volunteer-step-grid">

          <div className="volunteer-step">
            <span>01</span>
            <h3>Introduce Yourself</h3>
            <p>
              Tell us a little about yourself, your interests and the area
              where you would like to contribute.
            </p>
          </div>

          <div className="volunteer-step">
            <span>02</span>
            <h3>Choose Your Interest</h3>
            <p>
              Select the type of community activity that matches your skills
              and availability.
            </p>
          </div>

          <div className="volunteer-step">
            <span>03</span>
            <h3>Start Serving</h3>
            <p>
              Work respectfully with residents and fellow volunteers while
              learning from practical community experience.
            </p>
          </div>

        </div>
      </section>


      <section id="volunteer-join" className="volunteer-join">
        <div className="volunteer-join-card">

          <div className="volunteer-join-copy">
            <span className="volunteer-kicker">JOIN THE CIVIC VOLUNTEER NETWORK</span>
            <h2>Ready to contribute?</h2>
            <p>
              Share your details and interests. A volunteer coordinator can
              contact you with information about suitable community activities.
            </p>

            <div className="volunteer-join-points">
              <span><CheckCircle2 size={18} /> Community-focused</span>
              <span><CheckCircle2 size={18} /> Skills & leadership development</span>
              <span><CheckCircle2 size={18} /> Respectful and inclusive participation</span>
            </div>
          </div>

          <div className="volunteer-join-action">
            <div className="volunteer-join-icon">
              <Users size={28} />
            </div>

            <h3>Interested in helping your community?</h3>

            <p>
              Complete a short volunteer form and share the type of
              community service you are interested in.
            </p>

            <button
              type="button"
              className="volunteer-submit-btn"
              onClick={openVolunteerForm}
            >
              <Users size={18} />
              Volunteer Sign-up
            </button>

            <small className="volunteer-privacy-note">
              Your details are used only to respond to your volunteer request.
            </small>
          </div>

        </div>
      </section>


      <section className="volunteer-bottom">
        <h2>Serve. Learn. Lead.</h2>
        <p>
          Start by helping your community today. Leadership grows from
          responsibility, consistency and service.
        </p>

        <div className="volunteer-bottom-actions">
          <a href="#volunteer-join" className="volunteer-primary-btn">
            Become a Volunteer
          </a>

          <button
            type="button"
            className="volunteer-secondary-btn volunteer-back-btn"
            onClick={onBack}
          >
            Back to Home
          </button>
  

      {volunteerOpen && (
        <div
          className="civic-volunteer-modal-backdrop"
          onMouseDown={closeVolunteerForm}
        >
          <div
            className="civic-volunteer-modal"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="civic-volunteer-modal-close"
              onClick={closeVolunteerForm}
              aria-label="Close volunteer sign-up"
            >
              <X size={20} />
            </button>

            <div className="civic-volunteer-modal-icon">
              <Users size={26} />
            </div>

            <span className="volunteer-kicker">
              COMMUNITY VOLUNTEER
            </span>

            <h2>Volunteer Sign-up</h2>

            <p className="civic-volunteer-modal-intro">
              Tell us how you would like to contribute to your community.
            </p>

            <form
              className="civic-volunteer-form"
              onSubmit={submitVolunteer}
            >
              <label>
                Full Name
                <input
                  required
                  name="name"
                  placeholder="Your full name"
                  autoComplete="name"
                />
              </label>

              <label>
                Mobile Number
                <input
                  required
                  name="phone"
                  type="tel"
                  inputMode="numeric"
                  placeholder="10-digit mobile number"
                  autoComplete="tel"
                />
              </label>

              <label>
                Ward
                <select required name="area" defaultValue="">
                  <option value="" disabled>
                    Select your ward
                  </option>
                  {VIJAYANAGAR_WARDS.map((w) => (
                    <option
                      key={w.number}
                      value={`${w.number} - ${w.name}`}
                    >
                      {w.number} - {w.name}
                    </option>
                  ))}
                </select>
              </label>

              <label>
                Area of Interest
                <select required name="interest" defaultValue="">
                  <option value="" disabled>
                    Select an area
                  </option>
                  <option value="Leadership">Leadership</option>
                  <option value="Ward-level Community Coordination">
                    Ward-level Community Coordination
                  </option>
                  <option value="Youth Initiatives">
                    Youth Initiatives
                  </option>
                  <option value="Civic Awareness">
                    Civic Awareness
                  </option>
                  <option value="Neighbourhood Observation">
                    Neighbourhood Observation
                  </option>
                  <option value="Community Service">
                    Community Service
                  </option>
                </select>
              </label>

              <label>
                Tell us about yourself
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Your skills, interests or how you would like to contribute"
                />
              </label>

              {volunteerError && (
                <div className="civic-volunteer-error">
                  {volunteerError}
                </div>
              )}

              {submitted ? (
                <div className="civic-volunteer-success">
                  <CheckCircle2 size={21} />
                  <div>
                    <strong>Thank you for volunteering.</strong>
                    <span>
                      Your community volunteer request has been received.
                    </span>
                  </div>
                </div>
              ) : (
                <button
                  type="submit"
                  className="civic-volunteer-submit"
                  disabled={submitting}
                >
                  <Users size={18} />
                  {submitting
                    ? "Submitting..."
                    : "Submit Volunteer Request"}
                </button>
              )}
            </form>

            <p className="civic-volunteer-privacy">
              We collect only the information needed to respond to your
              volunteer request.
            </p>
          </div>
        </div>
      )}

      </div>
      </section>

    </div>
  );
}


export default VolunteerPage;
